import { CheckboxGroup_Field_default } from "./chunk-IUEJOYYF.js";
import { CheckboxGroup_default } from "./chunk-7UHJWYHI.js";
import { CheckableGroup_MoreButton_default } from "./chunk-LGNOJ3DG.js";

// src/components/CheckboxGroup/index.ts
var CheckboxGroupComponent = CheckboxGroup_default;
CheckboxGroupComponent.Field = CheckboxGroup_Field_default;
CheckboxGroupComponent.Field.displayName = "CheckboxGroup.Field";
CheckboxGroupComponent.MoreButton = CheckableGroup_MoreButton_default;
CheckboxGroupComponent.MoreButton.displayName = "CheckboxGroup.MoreButton";
export { CheckboxGroupComponent };